var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"modal",staticStyle:{"padding":"15px"},attrs:{"size":"lg","id":"feedbacksModal","title":"feedbacks","ok-title":"Submit","cancel-title":"Close"},on:{"show":function($event){return _vm.updateModel()},"hidden":function($event){return _vm.resetModal()},"ok":_vm.handleOk}}),_c('Toaster',{ref:"toaster"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }